// extracted by mini-css-extract-plugin
export var defaultWrapper = "_kb-3";
export var downloadButton = "_kb-4";
export var fileContainer = "_kb-9 _kb-7";
export var fileContainerBase = "_kb-7";
export var fileContainerFixedHeight = "_kb-8 _kb-7";
export var fileInfo = "_kb-5";
export var fileInfoWidthRestricted = "_kb-6";
export var fileType = "_kb-1";
export var fileTypeName = "_kb-2";
export var image = "_kb-0";
export var link = "_kb-b";
export var overflowEllipsis = "_kb-a";